import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetApiKeyHistoryListing(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingGetAPIKeyHistoryListingAtempt', handleGetApiKeyHistoryListing, api);
}

function* handleGetApiKeyHistoryListing(api: SettingGateway) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;
    const { index } = state.setting.apiKeyHistoryListing;

    if (!authToken && authToken === undefined) {
        yield put(combinedActions.settingGetAPIKeyHistoryListingFailure(ErrorMessages.GenericRequiredFieldNotProvided));
        return;
    }

    const response = yield* call([api, api.getApiKeyHistoryListing], { authToken, index });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingGetAPIKeyHistoryListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingGetAPIKeyHistoryListingSuccess(response.data));
    }
}
